import AdvocateHariPriyaIDetails from '../../components/about/advocates-details/HariPriya_I';
import Footer from '../../components/common/footer';
import Layout from '../../components/common/layout';
import NavigationMenu from '../../components/common/navigationMenu';
import PageHeader from '../../components/common/pageHeader';
import React from 'react';

const AdvocateHariPriyaIDetailsPage = () => {
  return (
    <Layout pageTitle='Avadhani & Associates | HariPriya Ippili'>
      <NavigationMenu active='about' />
      <PageHeader
        title='HariPriya Ippili'
        subMenu='Advocates'
        backLink='/about#team-section'
      />
      <AdvocateHariPriyaIDetails />
      <Footer />
    </Layout>
  );
};

export default AdvocateHariPriyaIDetailsPage;
